import { dataFetch } from '@lib/ggj-utils'

export default {
    downIdCard(params) {
        return dataFetch('/wholesale-activity/api/salary/agreement/frontBack', params, {
          'method': 'get'
        })
      },
}